import React, { useState } from "react"
import BoxComponent from "../../../../../../components/Box/BoxComponent";
import FormComponent from "../../../../../../components/form/FormComponent";
import SvgComponent from "../../../../../../components/Image/SvgComponent";
import LabelComponent from "../../../../../../components/Label/LabelComponent";
import TextFieldComponent from "../../../../../../components/TextField/TextFieldComponent";
import { inputStyle, labelStyle } from "../../../CatalogoPerfilPage";
import ButtonComponent from "../../../../../../components/Button/ButtonComponent";
import { LoginDTO } from "../../../../../../provider/auth/AuthProps";

interface CarrinhoLoginProps {
    telefone: string;
    onChangeTelefone: (telefone: string) => void;
    nomeUsuario: string;
    onChangeNomeUsuario: (nome: string) => void;

    bloqueiaCampoUsuario: boolean
}

const EtapaLoginComponent = (props: CarrinhoLoginProps) => {
    const handleLoginUser = (e: any) => {

    }

    return (
        <BoxComponent
            component="div"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center', // <--- Centraliza o formulário verticalmente no espaço do carrinho
                alignItems: 'center',
                width: '100%',
                flexGrow: 1,
                minHeight: 0,
                p: 2,                     // <--- Padding para o formulário não colar nas bordas do Paper
                boxSizing: 'border-box'   // <--- Evita que o padding cause overflow horizontal
            }}
        >
            <FormComponent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    p: 2.5,
                    width: "100%",
                    boxSizing: 'border-box', // <--- Importante aqui também devido ao width 100% + p
                    borderRadius: "12px",    // <--- Descomentei e suavizei para combinar com o Paper
                    backgroundColor: "#FFFFFF", // <--- Corrigido o "backgroundCOlor" (estava digitado errado)
                    boxShadow: `
                        0px 2px 4px -2px rgba(0,0,0,0.05), 
                        0px 4px 6px -1px rgba(0,0,0,0.05)
                    `, // Suavizado o shadow para ficar mais elegante
                    opacity: 1,
                }}
                onSubmit={(e: any) => handleLoginUser(e)}
            >
                <BoxComponent
                    component="fieldset"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        border: "0px",
                        p: 0, // Reseta o estofamento padrão do HTML fieldset
                        m: 0, // Reseta a margem padrão do HTML fieldset
                        width: "100%",
                    }}
                >
                    <LabelComponent
                        htmlFor="telefone"
                        sx={{
                            ...labelStyle,
                            width: "100%",
                            mb: 1 // Adiciona uma margemzinha entre o texto "Telefone" e o Input
                        }}
                    >
                        Telefone
                    </LabelComponent>

                    <TextFieldComponent
                        id="telefone"
                        value={props.telefone}
                        onChange={(e: any) => props.onChangeTelefone(e.target.value)}
                        required
                        maskTelefone
                        sx={{ ...inputStyle, width: "100%" }}
                        variant="outlined"
                        disableUnderline
                    />
                </BoxComponent>

                <BoxComponent
                    component="fieldset"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        border: "0px",
                        p: 0, // Reseta o estofamento padrão do HTML fieldset
                        m: 0, // Reseta a margem padrão do HTML fieldset
                        width: "100%",
                    }}
                >
                    <LabelComponent
                        htmlFor="nome"
                        sx={{
                            ...labelStyle,
                            width: "100%",
                            mb: 1
                        }}                        
                    >
                        Nome
                    </LabelComponent>

                    <TextFieldComponent
                        id="nome"
                        value={props.nomeUsuario}
                        placeholder="Seu nome completo"
                        onChange={(e: any) => props.onChangeNomeUsuario(e.target.value)}
                        required
                        sx={{ ...inputStyle, width: "100%" }}
                        variant="outlined"
                        disableUnderline
                        disabled={props.bloqueiaCampoUsuario}
                    />
                </BoxComponent>
            </FormComponent>
        </BoxComponent>
    );
}

export default EtapaLoginComponent;